import { isRateLimited } from '@dawn/core/utils';
import { QueryClient } from '@tanstack/react-query';

import { rateLimitRetryDelay } from './http-errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Only a 429 is retried, after the server's Retry-After (TDEV-1107)
      retry: (failureCount, error) => isRateLimited(error) && failureCount < 3,
      retryDelay: rateLimitRetryDelay,
      refetchOnWindowFocus: false,
    },
  },
});
